import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';
import { Theme } from '@material-ui/core/styles/createTheme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(0.5, 0),
      borderBottom: 'solid #eee 1px',
      '&.main2': {
        paddingTop: theme.spacing(2),
      },
      '&.noBorder': {
        borderBottom: 'none',
      },
      '&.sub': {
        paddingLeft: '20px'
      }
    },
  }),
);

export default useStyles;
